export default "__VITE_ASSET__f1c006b7__"